import App from './Login.svelte';
import 'bootstrap/dist/css/bootstrap.min.css';

const app = new App({
	target: document.body,
	// props: {
	// 	name: 'SvelteTest'
	// }
});

export default app;
